import {Component, OnDestroy, OnInit} from '@angular/core';
import {ContentService, ContentStateService} from '../../../services';
import {Subscription} from 'rxjs/Subscription';
import {ImageAsset} from '../../../model/typings/asset.types';
import {ViewContent} from '../../../model/typings/view.types';
import {Meta, Title} from '@angular/platform-browser';
import {ContentDetail, ContentDetailMessage, ContentMessageDetailType} from '../../../model/typings/content.types';
import {NavItem} from '../../../model/typings/nav.types';

@Component({
  selector: 'cpui-careers',
  templateUrl: './careers.component.html',
  styleUrls: ['./careers.component.scss']
})
export class CareersComponent implements OnInit, OnDestroy {
  isLoading = false;
  viewImageAssets: ImageAsset[];
  viewContent: ViewContent;
  backNavItem: NavItem;
  activeContentDetail: ContentDetail;
  private viewContentSubscription: Subscription;
  private contentLoaderSubscription: Subscription;
  private messageContentDetailSubscription: Subscription;

  constructor(private metaService: Meta,
              private titleService: Title,
              private contentService: ContentService,
              private contentStateService: ContentStateService) {
  }

  ngOnInit() {
    this.resetViewMeta();
    this.getViewContent();

    this.contentLoaderSubscription = this.contentService.isLoadingObservable.subscribe((isLoading: boolean) => {
      this.isLoading = isLoading;
    });

    this.messageContentDetailSubscription = this.contentStateService
      .activeMessageContentDetailObservable.subscribe(contentDetailMessage =>
        this.onActiveMessageContentDetailUpdate(contentDetailMessage));
  }

  ngOnDestroy() {
    if (this.contentLoaderSubscription) {
      this.contentLoaderSubscription.unsubscribe();
    }
    if (this.viewContentSubscription) {
      this.viewContentSubscription.unsubscribe();
    }
    if (this.messageContentDetailSubscription) {
      this.messageContentDetailSubscription.unsubscribe();
    }
  }

  onActiveMessageContentDetailUpdate(contentDetailMessage: ContentDetailMessage) {
    console.log(`CPUI - CareersComponent.onActiveMessageContentDetailUpdate()`);
    this.activeContentDetail = contentDetailMessage ? contentDetailMessage.contentDetail : null;
  }

  activateContentDetail(contentDetail: ContentDetail) {
    console.log(`CPUI - CareersComponent.activateContentDetail()`, contentDetail);

    const contentDetailMessage: ContentDetailMessage = (this.activeContentDetail === contentDetail) ? null : {
      id: `careersContent_${contentDetail.id}`,
      contentDetail,
      messageType: ContentMessageDetailType.READER
    };

    this.contentStateService.setActiveMessageContentDetail(contentDetailMessage);
  }

  getViewContent() {
    this.viewContentSubscription = this.contentService.getContentForView({viewId: 'careers', updateState: true})
      .subscribe((viewContent: ViewContent) => this.onViewContent(viewContent));
  }

  onViewContent(viewContent: ViewContent) {
    console.log(`CPUI - CareersComponent.onViewContent()`, viewContent);
    this.viewContent = viewContent;

    this.backNavItem = (viewContent.navItemAncestry instanceof Array) ? viewContent.navItemAncestry[0] : null;

    this.updateViewHeaderInfo(this.viewContent);

    if (this.viewContent.contentDetails) {
      console.log(`CPUI - CareersComponent.onViewContent()`, this.viewContent.contentDetails);
    }

    this.viewImageAssets = this.viewContent.imageAssets;
  }

  setViewMeta(description: string, author: string): void {
    console.log(`CPUI - CareersComponent.setViewMeta()`);
    if (description) {
      this.metaService.addTag({name: 'description', content: this.viewContent.description});
    }

    if (author) {
      this.metaService.addTag({name: 'author', content: this.viewContent.author});
    }
  }

  resetViewMeta(): void {
    console.log(`CPUI - CareersComponent.resetViewMeta()`);
    const author = this.metaService.getTag('name=author');
    const description = this.metaService.getTag('name=description');
    this.metaService.removeTagElement(author);
    this.metaService.removeTagElement(description);
  }

  updateViewHeaderInfo(viewContent: ViewContent): void {
    console.log(`CPUI - CareersComponent.updateViewHeaderInfo()`);
    this.resetViewMeta();
    const {title, description, author} = viewContent;

    this.setViewMeta(description, author);
    this.titleService.setTitle(title);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/views/careers/careers.component.ts